import React from 'react'

import { Button } from 'react-bootstrap'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import { ISelectOption } from '../../../../../../types/IClassifier'
import { HouseConsignmentRowData } from '../../../../house-consignment/components/types'
import Checkbox from '../../../../../../components/p5/Checkbox'
import DeleteIcon from '../../../../../../components/icons/DeleteIcon'
import EditIcon from '../../../../../../components/icons/EditIcon'

const getCountryLabel = (address: { country: string } | null | undefined, countriesOptions: ISelectOption[]): string | undefined => {
  if (!address) {
    return undefined
  }
  const {
    country,
  } = address

  return countriesOptions.find((countryOption) => countryOption.value === country)?.label
}

export interface EnsHouseConsignmentTableRowProps {
  houseConsignment: HouseConsignmentRowData
  houseConsignmentIndex: number
  onToggleConsignmentItems: () => void
  onRowEdit: () => void
  onRowRemove: () => void
  onRowSelect: () => void
  selected: boolean
  isExpanded: boolean
  editDisabled: boolean
  consignmentItemsToggleDisabled: boolean
}

function EnsHouseConsignmentsTableRow({
  houseConsignment,
  houseConsignmentIndex,
  onToggleConsignmentItems,
  onRowEdit,
  onRowRemove,
  onRowSelect,
  selected,
  isExpanded,
  editDisabled,
  consignmentItemsToggleDisabled,
} : EnsHouseConsignmentTableRowProps) {
  const [, countriesOptions] = useCodelist('COUNTRIES')

  return (
    <tr
      className={`${houseConsignment.invalidCommodityData ? 'invalid-row' : ''} ${isExpanded ? 'hc-row-expanded' : ''} ${consignmentItemsToggleDisabled ? '' : 'hc-row-clickable'} ${selected ? 'row-selected' : ''}`}
      onClick={consignmentItemsToggleDisabled ? undefined : onToggleConsignmentItems}
    >
      <td className="w-1 align-middle">
        <Checkbox
          checked={selected}
          onChange={onRowSelect}
          onClick={(event) => event.stopPropagation()}
          wrapperClassName="d-flex align-items-center justify-content-center"
          inputClassName="form-check-input m-0 float-none"
        />
      </td>
      <td className="sequence-nr">{houseConsignmentIndex + 1}</td>
      <td>{houseConsignment.seller?.name}</td>
      <td>{getCountryLabel(houseConsignment.seller?.address, countriesOptions)}</td>
      <td>{houseConsignment.buyer?.name}</td>
      <td>{getCountryLabel(houseConsignment.buyer?.address, countriesOptions)}</td>
      <td>
        <Button
          type="button"
          variant="link"
          className="goods-toggle"
          onClick={(event) => {
            event.stopPropagation()
            onToggleConsignmentItems()
          }}
          active={isExpanded}
          disabled={consignmentItemsToggleDisabled}
          title="goods"
        >
          <span className={`goods-toggle__count ${houseConsignment.invalidCommodityData ? 'goods-toggle__count--invalid' : ''}`}>
            {houseConsignment.numberOfGoods}
          </span>
        </Button>
      </td>
      <td className="text-end">
        <div className="d-flex align-items-center justify-content-end gap-2">
          <Button
            type="button"
            variant="link"
            className="btn-icon"
            onClick={(event) => {
              event.stopPropagation()
              onRowEdit()
            }}
            disabled={editDisabled}
          >
            <EditIcon />
          </Button>
          <Button
            type="button"
            variant="link"
            className="btn-trash"
            onClick={(event) => {
              event.stopPropagation()
              onRowRemove()
            }}
            disabled={editDisabled}
          >
            <DeleteIcon />
          </Button>
        </div>
      </td>
    </tr>
  )
}

export default EnsHouseConsignmentsTableRow
